import { ONBOARDING_CHANGED } from '../redux/tracking';
import get from 'lodash/get';

import type { OnboardingChanged, EventTracking } from '../types';

import type { TrackingActionWithIndex } from '../types/tracking';

/** @type {ActionType} */
export const pbr_onboarding_changed = 'pbr_onboarding_changed';

function onboardingChanged(action: OnboardingChanged): TrackingActionWithIndex {
  return {
    index: get(action, 'payload.index') + 1,
  };
}

// Make sure you cast this before you export it in your duckling.

const tracking: EventTracking = {};
tracking[ONBOARDING_CHANGED] = onboardingChanged;

export default tracking;
